<template>
    <Head :title="pageTitle"/>
    <student-time-tracker/>
    <FlashMessages/>

    <HoneybadgerErrorTracking/>

    <div class="flex min-h-screen flex-col text-gray-925">
        <!-- mobile header and slide over menu-->
        <div
            class="flex h-16 items-center justify-between bg-gray-825 px-4 lg:hidden"
        >
            <div class="">
                <Link :href="route('student.dashboard')">
                    <img
                        class="h-8"
                        src="/assets/art/logos/emtprep_logo_ondark@2x.png"
                    />
                </Link>
            </div>

            <slide-over-menu
                open-from="right"
                :px-width="320"
                css-classes="lg:hidden"
            >
                <template #trigger>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 6C1 5.44772 1.44772 5 2 5H22C22.5523 5 23 5.44772 23 6C23 6.55228 22.5523 7 22 7H2C1.44772 7 1 6.55228 1 6Z"
                            fill="#E1E5E8"
                        />
                        <path
                            d="M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z"
                            fill="#E1E5E8"
                        />
                        <path
                            d="M1 18C1 17.4477 1.44772 17 2 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H2C1.44772 19 1 18.5523 1 18Z"
                            fill="#E1E5E8"
                        />
                    </svg>
                </template>
                <template #menu_content>
                    <div class="flex h-full flex-col overflow-y-auto bg-white">
                        <div class="flex flex-col gap-2 px-4 py-4">
                            <div class="flex justify-start gap-4">
                                <div class="h-12">
                                    <img
                                        v-if="$page.props.auth.user.avatar"
                                        class="h-10 w-10 rounded rounded-full bg-primary-darker"
                                        :src="$page.props.auth.user.avatar"
                                    />
                                    <span
                                        v-else
                                        class="rounded rounded-full bg-primary-darker p-3 text-[14px] font-bold text-white"
                                    >{{
                                            $page.props.auth.user.initials
                                        }}</span
                                    >
                                </div>
                                <div
                                    class="flex w-52 flex-none flex-col text-[20px] font-semibold"
                                >
                                    <div class="">
                                        <text-clamp
                                            autoResize
                                            :max-lines="1"
                                            :text="
                                                $page.props.auth.user.full_name
                                            "
                                        ></text-clamp>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <span
                                            class="text-[16px] font-normal text-gray-925 lg:font-semibold lg:text-white"
                                        >{{
                                                $page.props.auth.user
                                                    .provider_level.title
                                            }}</span
                                        >
                                        <Link
                                            :href="
                                                route(
                                                    'student.account.manage'
                                                ) + '#provider-level'
                                            "
                                            class="text-[14px] font-medium text-primary-525 underline"
                                        >Change Level
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-4"></div>
                        <student-sidebar-navigation/>
                        <div class="flex-grow"></div>
                        <div class="flex flex-col gap-3 p-4">
                            <ul class="flex flex-col gap-4">
                                <li>
                                    <Link
                                        class="text-primary-525"
                                        :href="route('student.account.manage')"
                                    >
                                        <div
                                            class="flex items-center justify-start gap-2"
                                        >
                                            <div class="underline">
                                                Account Settings
                                            </div>
                                            <div class="">
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g
                                                        clip-path="url(#clip0_1312_11974)"
                                                    >
                                                        <path
                                                            d="M9 16.5015C13.1421 16.5015 16.5 13.1436 16.5 9.00146C16.5 4.85933 13.1421 1.50146 9 1.50146C4.85786 1.50146 1.5 4.85933 1.5 9.00146C1.5 13.1436 4.85786 16.5015 9 16.5015Z"
                                                            stroke="#0685BB"
                                                            stroke-width="1.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                        <path
                                                            d="M9 12.0015L12 9.00146L9 6.00146"
                                                            stroke="#0685BB"
                                                            stroke-width="1.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                        <path
                                                            d="M6 9H12"
                                                            stroke="#0685BB"
                                                            stroke-width="1.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath
                                                            id="clip0_1312_11974"
                                                        >
                                                            <rect
                                                                width="18"
                                                                height="18"
                                                                fill="white"
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                        </div>
                                    </Link>
                                </li>

                                <li>
                                    <div
                                        class="flex items-center gap-4 rounded border border-gray-325 p-2"
                                    >
                                        <div class="">
                                            <svg
                                                width="21"
                                                height="22"
                                                viewBox="0 0 21 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g opacity="0.67">
                                                    <path
                                                        d="M16.625 4H4.375C3.4085 4 2.625 4.7835 2.625 5.75V18C2.625 18.9665 3.4085 19.75 4.375 19.75H16.625C17.5915 19.75 18.375 18.9665 18.375 18V5.75C18.375 4.7835 17.5915 4 16.625 4Z"
                                                        stroke="#767C8D"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M14 2.25V5.75"
                                                        stroke="#767C8D"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M7 2.25V5.75"
                                                        stroke="#767C8D"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M2.625 9.25H18.375"
                                                        stroke="#767C8D"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="text-gray-700">
                                            <student-test-day/>
                                        </div>
                                    </div>
                                </li>
                                <li class="mt-8">
                                    <a
                                        v-if="$page.props.is_being_impersonated"
                                        class="btn btn-secondary w-full"
                                        :href="route('impersonate.leave')"
                                    >
                                        Stop Impersonating
                                    </a>

                                    <a
                                        v-else
                                        class="btn btn-secondary w-full"
                                        :href="route('logout')"
                                    >Log Out
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </slide-over-menu>
        </div>
        <!-- mobile super banner-->
        <div
            :class="
                'w-full border-b border-primary-350 py-2 lg:hidden' +
                ' ' +
                'bg-' +
                superBannerColor
            "
            v-if="$slots.super_banner"
        >
            <slot name="super_banner"/>
        </div>
        <main class="flex flex-grow bg-white">
            <!-- desktop sidebar-->
            <div
                class="hidden w-[290px] flex-none bg-gray-825 lg:flex lg:flex-col"
            >
                <div
                    class="mb-2 flex h-16 w-full items-center justify-start px-4"
                >
                    <img
                        class="h-8"
                        src="/assets/art/logos/emtprep_logo_ondark@2x.png"
                    />
                </div>

                <student-sidebar-navigation/>
            </div>

            <div
                :class="
                    'mx-auto flex flex-grow flex-col bg-gray-125' +
                    ' ' +
                    ('bg-' + contentBgColor)
                "
            >
                <!-- desktop super banner-->
                <div
                    :class="
                        'hidden w-full lg:block' +
                        ' ' +
                        'bg-' +
                        superBannerColor
                    "
                    v-if="$slots.super_banner"
                >
                    <div class="mx-auto w-auto max-w-[1440px] px-4 lg:px-10">
                        <slot name="super_banner"/>
                    </div>
                </div>
                <!-- desktop page top bar -->
                <div
                    v-if="showTopBar"
                    class="hidden border-b border-gray-325 bg-white lg:block"
                >
                    <div class="mx-auto w-auto max-w-[1440px] px-4 lg:px-10">
                        <div class="flex h-14 items-center justify-between">
                            <div class="">
                                <student-test-day/>
                            </div>
                            <div class="flex items-center gap-2">
                                <span
                                    class="text-[16px] font-semibold text-gray-700"
                                >{{
                                        $page.props.auth.user.provider_level
                                            .title
                                    }}</span
                                >
                                <Link
                                    :href="
                                        route('student.account.manage') +
                                        '#provider-level'
                                    "
                                    class="text-[14px] font-medium text-primary-500"
                                >Change Level
                                </Link>
                                <dropdown :px-width="300">
                                    <template #button>
                                        <div class="flex items-center gap-2">
                                            <div class="">
                                                <img
                                                    v-if="
                                                        $page.props.auth.user
                                                            .avatar
                                                    "
                                                    class="h-10 w-10 rounded rounded-full bg-primary-darker"
                                                    :src="
                                                        $page.props.auth.user
                                                            .avatar
                                                    "
                                                />
                                                <span
                                                    v-else
                                                    class="rounded rounded-full bg-primary-darker p-3 text-[14px] font-bold text-white"
                                                >{{
                                                        $page.props.auth.user
                                                            .initials
                                                    }}</span
                                                >
                                            </div>
                                            <div class="">
                                                <svg
                                                    width="20"
                                                    height="21"
                                                    viewBox="0 0 20 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M5 8L10 13L15 8"
                                                        stroke="#5D6375"
                                                        stroke-width="1.66667"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </template>
                                    <template #content>
                                        <div class="bg-white shadow">
                                            <ul>
                                                <li
                                                    class="hover:cursor-pointer hover:bg-gray-200"
                                                >
                                                    <Link
                                                        class="block p-4"
                                                        :href="
                                                            route(
                                                                'student.account.manage'
                                                            )
                                                        "
                                                    >
                                                        Account Settings
                                                    </Link>
                                                </li>
                                                <li
                                                    class="hover:cursor-pointer hover:bg-gray-200"
                                                >
                                                    <Link
                                                        class="block p-4"
                                                        :href="
                                                            route(
                                                                'student.payment-history'
                                                            )
                                                        "
                                                    >
                                                        Payment History
                                                    </Link>
                                                </li>
                                                <li
                                                    class="hover:cursor-pointer hover:bg-gray-200"
                                                >
                                                    <a
                                                        v-if="
                                                            $page.props
                                                                .is_being_impersonated
                                                        "
                                                        class="block p-4 text-red-400"
                                                        :href="
                                                            route(
                                                                'impersonate.leave'
                                                            )
                                                        "
                                                    >
                                                        Stop Impersonating
                                                    </a>
                                                    <a
                                                        v-else
                                                        class="block p-4 text-red-400"
                                                        :href="route('logout')"
                                                    >Log Out
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <!-- main content -->
                    <div class="">
                        <div
                            :class="'w-full' + ' bg-' + headerBgColor"
                            v-if="$slots.page_header"
                        >
                            <div
                                class="mx-auto w-auto max-w-[1440px] px-4 py-4 lg:px-10"
                            >
                                <slot name="page_header"/>
                            </div>
                        </div>
                        <div class="w-full">
                            <div class="mx-auto w-auto max-w-[1440px]">
                                <slot name="content"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import FlashMessages from "@/Components/FlashMessages";
import StudentSidebarNavigation from "@/_Layouts/StudentSidebarNavigation.vue";
import StudentTestDay from "@/Components/StudentTestDay.vue";
import UserAvatarRound from "@/Components/UserAvatarRound.vue";
import Dropdown from "@/Components/Dropdown.vue";
import SlideOverMenu from "@/Components/SlideOverMenu.vue";
import StudentChangeProviderLevel from "@/Components/StudentChangeProviderLevel.vue";
import StudentTimeTracker from "@/Components/StudentTimeTracker.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "StudentBackendLayout",
    components: {
        HoneybadgerErrorTracking,
        StudentTimeTracker,
        StudentChangeProviderLevel,
        SlideOverMenu,
        Dropdown,
        UserAvatarRound,
        StudentTestDay,
        StudentSidebarNavigation,
        FlashMessages,
    },
    props: {
        hideHeader: {
            type: Boolean,
            default: false,
        },
        pageTitle: {
            type: String,
            default: "",
        },
        headerBgColor: {
            type: String,
            default: "gray-100",
        },
        contentBgColor: {
            type: String,
            default: "white",
        },
        superBannerColor: {
            type: String,
            default: "primary-150",
        },
        showTopBar: {
            type: Boolean,
            default: true,
        },
    },

    methods: {},
};
</script>
